import { Button, EmptyState, Spinner } from '@bifeai/ui';
import { Lock } from 'lucide-react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { api, isApiError } from '../lib/api';
import { SessionProvider, useMeQuery } from '../lib/session';
import { AppLayout } from './AppLayout';

/**
 * Puerta de entrada a la app: sin sesión va al login; con pasos pendientes
 * (2FA o contraseña temporal) va a completarlos; si no, muestra la app.
 */
export function Protected() {
  const location = useLocation();
  const { data: me, error, isPending } = useMeQuery();

  if (isPending) {
    return (
      <div className="bf-center-screen">
        <Spinner label="Cargando tu carnicería" />
      </div>
    );
  }

  if (error) {
    if (isApiError(error, 'LICENSE_SUSPENDED', 'ACCOUNT_DISABLED')) {
      return (
        <div className="bf-center-screen">
          <EmptyState
            icon={<Lock />}
            title="No podés ingresar"
            text={error.message}
            action={
              <Button onClick={() => void api.post('/auth/logout').finally(() => window.location.assign('/ingresar'))}>Volver al inicio</Button>
            }
          />
        </div>
      );
    }
    const next = location.pathname !== '/' ? `?next=${encodeURIComponent(location.pathname)}` : '';
    return <Navigate to={`/ingresar${next}`} replace />;
  }

  if (!me.session.mfaVerified) {
    return <Navigate to={me.session.mfaSetupRequired ? '/activar-2fa' : '/ingresar/codigo'} replace />;
  }
  if (me.user.mustChangePassword) return <Navigate to="/cambiar-clave" replace />;

  return (
    <SessionProvider me={me}>
      {/* El celular del repartidor va a pantalla completa, sin el menú del sistema. */}
      {location.pathname === '/reparto' ? <Outlet /> : <AppLayout />}
    </SessionProvider>
  );
}
